<template>
  <div class="steps">
    <div class="bottom-logo">
      <img src="~@/assets/imgs/camel-logo.svg" />
    </div>
    <div class="inner">
      <ul class="step-numbers">
          <li class="step-item" :class="{active: currentPage == 1}">
            <div class="step-number">1</div>
            <div class="step-title">Design</div>
          </li>
          <li class="step-item" :class="{active: currentPage == 2}">
            <div class="step-number">2</div>
            <div class="step-title">Vorschau</div>
          </li>
          <li class="step-item" :class="{active: currentPage == 3}">
            <div class="step-number">3</div>
            <div class="step-title">Deine Daten</div>
          </li>
          <li class="step-item" :class="{active: currentPage == 4}">
            <div class="step-number">4</div>
            <div class="step-title">Fertig</div>
          </li>
      </ul>
      <div class="back-to-home" v-if="currentPage == 4">
        <b-button @click="goStart()" variant="secondary">Neustart</b-button>
        <div class="back-to-home__text">Automatischer Neustart in <span>{{ timerCount }}</span> Sekunden</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Head",
  props: {
    currentPage: {
      type:Number,
      required: true
    }
  },
  data() {
    return {
      timerCount: 5,
    }
  },
  computed: {
    cssClass: function() {
      return `step-${this.currentPage}`
    }
  },
  mounted: function () {
    this.stepsCheck();
  },
  methods: {
    goStart() {
      this.$emit('start')
    },
    countDownTimer () {
      if (this.timerCount > 0) {
          setTimeout(() => {
              this.timerCount -= 1
              this.countDownTimer()
          }, 1000)
      } else {
        this.goStart()
      }
    },
    stepsCheck: function() {
      const stepsChecker = setInterval(() => {
        if(this.currentPage == 4) {
          clearInterval(stepsChecker)
          setTimeout(() => {
            this.countDownTimer()
          }, 5000)
        }
      }, 500)
    }
  }
}
</script>
<style lang="scss" scoped>
.steps {
  position: fixed;
  background-color: white;
  height: 140px;
  display: flex;
  align-items: center;
  bottom: 0;
  left: 0;
  right: 0;
}
.inner {
  width: 100%;
  height: 60px;
}
.step-numbers {
  padding: 0;
  margin: 0;
  max-width: 520px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: space-between;
  list-style: none;
  background-image: url('~@/assets/imgs/background-line.png');
  background-repeat: repeat-x;
  background-position: left center;
}
.step-item {
  position: relative;
  text-align: center;
}
.step-number {
  display: inline-block;
  height: 26px;
  width: 26px;
  font-family: Helvetica;
  font-size: 16px;
  font-weight: bold;
  line-height: 26px;
  text-align: center;
  background-color: #F1F1F2;
  color: #00A3E0;
  border-radius: 50%;
  white-space: nowrap;

  .active & {
    background-color: #00A3E0;
    color: #ffffff;
  }
}
.step-title {
  position: absolute;
  left: 50%;
  margin-top: 16px;
  color: #939393;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  opacity: 0.37;
  transform: translateX(-50%);
  white-space: nowrap;

  .active & {
    color: #00A3E0;
    opacity: 1;
  }
}
.back-to-home {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 20px;
  text-align: center;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.back-to-home__text {
  margin-top: 15px;
  color: #939393;
  opacity: 0.37;
}
.bottom-logo {
  position: absolute;
  top: -23px;
  right: 30px;
  max-width: 100px;
  transform: translateY(-100%);
  z-index: -1;
  pointer-events: none;

  img {
    max-width: 100px;
  }
}
</style>
